<template>
  <div class="appcon">
    <div
      class="header"
      :style="{
        backgroundColor: activename === 'appabout' ? '#54677f' : '#FFEF00'
      }"
    >
      <img
        src="../assets/images/title2.png"
        alt=""
        v-if="activename === 'appabout'"
      />
      <img
        src="../assets/images/title1.png"
        alt=""
        v-if="activename !== 'appabout'"
      />
      <div
        class="navbar-toggle "
        data-toggle="collapse"
        data-target="#header-navbar"
        @click="tabclick"
      >
        <span
          class="icon-bar"
          :style="{
            backgroundColor: activename === 'appabout' ? '#ffffff' : '#000000'
          }"
        ></span>
        <span
          class="icon-bar"
          :style="{
            backgroundColor: activename === 'appabout' ? '#ffffff' : '#000000'
          }"
        ></span>
        <span
          class="icon-bar"
          :style="{
            backgroundColor: activename === 'appabout' ? '#ffffff' : '#000000'
          }"
        ></span>
      </div>
    </div>
    <div
      class="header"
      style="backgroundColor:#f7f7f7"
      v-if="activename === 'apprecruitment'"
    >
      <img
        src="../assets/images/title2.png"
        alt=""
        v-if="activename === 'appabout'"
      />
      <img
        src="../assets/images/title1.png"
        alt=""
        v-if="activename !== 'appabout'"
      />
      <div
        class="navbar-toggle "
        data-toggle="collapse"
        data-target="#header-navbar"
        @click="tabclick"
      >
        <span
          class="icon-bar"
          :style="{
            backgroundColor: activename === 'appabout' ? '#ffffff' : '#000000'
          }"
        ></span>
        <span
          class="icon-bar"
          :style="{
            backgroundColor: activename === 'appabout' ? '#ffffff' : '#000000'
          }"
        ></span>
        <span
          class="icon-bar"
          :style="{
            backgroundColor: activename === 'appabout' ? '#ffffff' : '#000000'
          }"
        ></span>
      </div>
    </div>
    <div id="navbarlist" v-if="tabhide">
      <span style="color: #ffff;" @click="active('apphome')">首页(Home) </span>
      <span style="color: #ffff;" @click="active('appabout')"
        >关于我们(About)</span
      >
      <!-- <span style="color: #ffff;" @click="active('appteam')"
        >团队简介(Team)</span
      > -->
      <span style="color: #ffff;" @click="active('apptroducts')"
        >青牛产品(Products)</span
      >
      <span style="color: #ffff;" @click="active('apprecruitment')"
        >伙伴招募(Recruitment)</span
      >
      <span style="color: #ffff;" @click="active('appseries')"
        >动漫表情包(Expression)</span
      >
    </div>
    <div
      class="appcontent"
      :style="{
        backgroundColor: activename === 'appabout' ? '#54677f' : '#FFEF00'
      }"
    >
      <img
        src="../assets/images/Font_logoW@2x.png"
        alt=""
        v-if="activename == 'apphome'"
        class="homeimg"
      />
      <m-appabout v-if="activename == 'appabout'"></m-appabout>
      <m-appteam v-if="activename == 'appteam'"></m-appteam>
      <m-apptroducts v-if="activename == 'apptroducts'"></m-apptroducts>
      <m-apprecruitment
        v-if="activename == 'apprecruitment'"
      ></m-apprecruitment>
      <m-appseries v-if="activename == 'appseries'"></m-appseries>
      <!--  -->
    </div>
    <m-appmessage></m-appmessage>
  </div>
</template>
<script>
import mAppmessage from '../components/appmessage'
import mAppabout from '../components/appabout'
import mAppteam from '../components/appteam'
import mApptroducts from '../components/apptroducts'
import mApprecruitment from '../components/apprecruitment'
import mAppseries from '../components/appseries'
export default {
  components: {
    mAppmessage,
    mAppabout,
    mAppteam,
    mApptroducts,
    mApprecruitment,
    mAppseries
  },
  data () {
    return {
      tabhide: false,
      activename: 'apphome'
    }
  },
  created () {},
  mounted () {},
  methods: {
    tabclick () {
      this.tabhide = !this.tabhide
    },
    active (name) {
      console.log(name)
      this.activename = name
      this.tabhide = !this.tabhide
    }
  }
}
</script>
<style lang="less">
.header {
}
.header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 50px;
  padding: 0 5%;
  z-index: 20;
  background-color: #f7f7f7;
  box-sizing: border-box;

  img {
    width: 80px;
    margin-top: 17px;
    margin-left: 10px;
  }
  .navbar-toggle {
    float: right;
    padding: 5px 10px;
    margin-top: 8px;
    // margin-right: 15px;
    margin-bottom: 8px;
    background-color: transparent;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: none;
    .icon-bar {
      display: block;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background-color: #333;
      margin-top: 4px;
    }
  }
}
#navbarlist {
  position: fixed;
  right: 0;
  top: 50px;
  width: 50%;
  border-radius: 10px 0 0 10px;
  padding: 5px 10px;
  background-color: #000000;
  z-index: 10;
  span {
    display: block;
    text-align: center;
    border-bottom: 1px solid #ffffff;
    font-size: 14px;
    padding: 5px;
    color: #ffffff;
  }
  :last-child {
    border: none;
  }
}
.appcontent {
  min-height: 90%;
  width: 100%;
  // display: flex;
  //   align-items: center;
  background: #f7f7f7;
}
.isapp {
  width: 100%;
  height: 100%;
}
.appcon {
  width: 100%;
  height: 100%;
}
.homeimg {
  width: 66%;
  margin-top: 60%;
  margin-left: 16%;
}
@media screen and (min-width: 750px) {
  .header {
    padding: 0 5%;
    height: 100px;
    img {
      width: 15%;
      margin-top: 30px;
      margin-left: 10px;
    }
    .navbar-toggle {
      border-radius: 8px;
      margin-top: 20px;
      margin-bottom: 10px;
      border: none;
      .icon-bar {
        display: block;
        width: 44px;
        height: 6px;
        border-radius: 1px;
        background-color: #333;
        margin-top: 6px;
      }
    }
  }
  #navbarlist {
    position: fixed;
    top: 100px;
    width: 40%;
    border-radius: 10px 0 0 10px;
    padding: 5px 10px;
    z-index: 10;
    span {
      font-size: 26px;
      padding: 10px;
    }
  }

  .homeimg {
    width: 66%;
    margin-top: 35%;
    margin-left: 16%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apphome.vue